const ExplanationTableRow = ({
  columnName,
  columnDescription,
  shouldCenterDescription = false,
}: {
  columnName: String;
  columnDescription: String;
  shouldCenterDescription?: boolean;
}) => (
  <tr>
    <td className='border-gray border-t text-center'>{columnName}</td>
    <td className={`whitespace-pre-line border-gray border-s border-t px-2.5 py-1.5 ${shouldCenterDescription ? 'text-center' : ''}`}>{columnDescription}</td>
  </tr>
);

export default ExplanationTableRow;
